import { IPayloadAction } from '../session/session.actions';

export const PendingActions = {
  UPDATE_PENDING: '[Pending] Update Pending',
  UPDATE_PENDING_COMPLETED: '[Pending] Update Pending Complete',
};

export class UpdatePending implements IPayloadAction {
  readonly type = PendingActions.UPDATE_PENDING;
}

export class UpdatePendingCompleted implements IPayloadAction {
  readonly type = PendingActions.UPDATE_PENDING_COMPLETED;
}
